"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewDeckCreateWrapper = function ReviewDeckCreateWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selected", _descriptor, _this);
      _initializerDefineProperty(_this, "duplicateNameError", _descriptor2, _this);
      _initializerDefineProperty(_this, "askForDeleteConfirmation", _descriptor3, _this);
      _initializerDefineProperty(_this, "askForDeleteCardsConfirmation", _descriptor4, _this);
      _initializerDefineProperty(_this, "askForResetConfirmation", _descriptor5, _this);
      _initializerDefineProperty(_this, "message", _descriptor6, _this);
      _initializerDefineProperty(_this, "deletingDeck", _descriptor7, _this);
      _initializerDefineProperty(_this, "deletingCards", _descriptor8, _this);
      _initializerDefineProperty(_this, "resettingReviews", _descriptor9, _this);
      _initializerDefineProperty(_this, "afterCreateDeck", _descriptor0, _this);
      _initializerDefineProperty(_this, "dailyGoalMin", _descriptor1, _this);
      _initializerDefineProperty(_this, "dailyGoalIsTooLow", _descriptor10, _this);
      _this.onSetName = function (name) {
        _this.selected['name'] = name;
        _this.duplicateNameError = (0, _utils.isPresent)(_state.AppUI.reviewDeckStore.indexData.find(function (item) {
          var _item$name;
          return ((0, _utils.isBlank)(_this.props.deck) || item.id !== _this.props.deck.id) && (item === null || item === void 0 || (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.toLowerCase()) === (name === null || name === void 0 ? void 0 : name.toLowerCase());
        }));
      };
      _this.onSetDailyGoal = function (dailyGoal) {
        _this.selected['dailyGoal'] = dailyGoal;
        setTimeout(_this.setDailyGoalIsTooLow, 800);
      };
      _this.setDailyGoalIsTooLow = function () {
        _this.dailyGoalIsTooLow = _this.dailyGoal < _this.dailyGoalMin && _this.dirtyField('dailyGoal') && !(0, _utils.isBlank)(_this.dailyGoal);
      };
      _this.onSetColor = function (color) {
        _this.selected['color'] = color;
      };
      _this.dirtyField = function (field) {
        return (0, _utils.isPresent)(_this.selected[field]) && (!_this.props.deck || _this.selected[field] !== _this.props.deck[field]);
      };
      _this.onSetAskForDeleteConfirmation = function (askForDeleteConfirmation) {
        _this.askForDeleteConfirmation = askForDeleteConfirmation;
      };
      _this.onSetAskForResetConfirmation = function (askForResetConfirmation) {
        _this.askForResetConfirmation = askForResetConfirmation;
      };
      _this.onSetAskForDeleteCardsConfirmation = function (askForDeleteCardsConfirmation) {
        _this.askForDeleteCardsConfirmation = askForDeleteCardsConfirmation;
      };
      _this.onToggleDefaultReviewDeck = function () {
        _this.selected['defaultReviewDeck'] = !_this.defaultReviewDeck;
      };
      _this.onToggleUseDailyGoal = function () {
        var turningOn = !_this.useDailyGoal;
        _this.selected['useDailyGoal'] = turningOn;
        if (turningOn && (0, _utils.isBlank)(_this.dailyGoal)) {
          _this.selected['dailyGoal'] = _this.dailyGoalMin;
        }
      };
      _this.onToggleArchived = function () {
        var _this$props$deck;
        if ((_this$props$deck = _this.props.deck) !== null && _this$props$deck !== void 0 && _this$props$deck.defaultReviewDeck) {
          _this.message = 'Default decks cannot be archived.';
        } else {
          _this.selected['archived'] = !_this.archived;
        }
      };
      _this.onChangeLanguage = function (value) {
        _this.selected['languageId'] = value;
      };
      _this.updateReviewAfter = function (numberDays) {
        _state.AppUI.deckStore.updateReviewAfter({
          ids: {
            deckId: _this.props.deck.id
          },
          data: {
            number_days: numberDays
          }
        }, _this.afterUpdateReviewAfter.bind(_this, numberDays));
      };
      _this.afterUpdateReviewAfter = function (numberDays, resp) {
        if (resp.success) {
          var days = numberDays === 1 ? '1 day' : "".concat(numberDays, " days");
          _this.message = "Your reviews have been pushed forward ".concat(days, ".");
          setTimeout(function () {
            return _this.message = null;
          }, 3000);
          _state.AppUI.reviewDeckStore.getIndex({});
        }
      };
      _this.onSubmit = function () {
        if (!_this.enabledSubmitButton) {
          return;
        }
        var data = {
          userId: _state.AppUI.user.id,
          deckType: 'review',
          name: _this.name,
          color: _this.color,
          defaultReviewDeck: _this.defaultReviewDeck,
          useDailyGoal: _this.useDailyGoal,
          languageId: _this.languageId,
          archived: _this.archived,
          dailyGoal: _this.dailyGoal
        };
        if (_this.props.deck) {
          _this.props.deck.set('name', _this.name);
          _this.props.deck.set('color', _this.color);
          _this.props.deck.set('defaultReviewDeck', _this.defaultReviewDeck);
          _this.props.deck.set('useDailyGoal', _this.useDailyGoal);
          _this.props.deck.set('archived', _this.archived);
          _this.props.deck.set('dailyGoal', _this.dailyGoal);
          _state.AppUI.deckStore.update({
            ids: {
              deckId: _this.props.deck.id
            },
            data: data
          }, _this.afterUpdate);
        } else {
          _state.AppUI.deckStore.create({
            data: data
          }, _this.afterCreate);
        }
      };
      _this.onDeleteDeck = function () {
        if (!_this.deletingDeck) {
          _this.deletingDeck = true;
          var deckId = _this.props.deck.id;
          if (_state.AppUI.layout.isNative) {
            var _this$props$closeOpti, _this$props;
            _state.AppUI.reviewDeckStore.set('indexData', _state.AppUI.reviewDeckStore.indexData.filter(function (item) {
              return item.id !== deckId;
            }));
            (_this$props$closeOpti = (_this$props = _this.props).closeOptions) === null || _this$props$closeOpti === void 0 || _this$props$closeOpti.call(_this$props);
            _state.AppUI.deckStore.destroy({
              ids: {
                deckId: deckId
              }
            }, function () {});
          } else {
            _state.AppUI.deckStore.destroy({
              ids: {
                deckId: deckId
              }
            }, _this.props.closeOptionsAndUpdate);
          }
        }
      };
      _this.onDeleteCards = function () {
        if (!_this.deletingCards) {
          _this.deletingCards = true;
          _state.AppUI.deckStore.deleteReviewCards({
            ids: {
              deckId: _this.props.deck.id
            }
          }, _this.props.closeOptionsAndUpdate);
        }
      };
      _this.onResetCards = function () {
        _this.resettingReviews = true;
        _state.AppUI.deckStore.resetReviewCards({
          ids: {
            deckId: _this.props.deck.id
          }
        }, _this.props.closeOptionsAndUpdate);
      };
      _this.afterUpdate = function () {
        var _this$props$onToggleE, _this$props2;
        _this.resetForm();
        _this.loadDecks();
        (_this$props$onToggleE = (_this$props2 = _this.props).onToggleEdit) === null || _this$props$onToggleE === void 0 || _this$props$onToggleE.call(_this$props2);
      };
      _this.afterCreate = function () {
        _this.message = 'This deck has been created. ';
        _this.resetForm();
        _this.loadDecks();
        _this.afterCreateDeck = true;
      };
      _this.resetForm = function () {
        _this.selected = {
          name: null,
          color: null,
          defaultReviewDeck: null,
          useDailyGoal: null,
          languageId: _this.languageId
        };
        if ((0, _utils.isPresent)(_this.props.deck)) {
          _this.selected['dailyGoal'] = _this.props.deck.dailyGoal;
        }
      };
      _this.loadDecks = function () {
        _state.AppUI.reviewDeckStore.getIndex();
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "name",
      get: function get() {
        var _this$props$deck2;
        return this.selected['name'] === null ? (_this$props$deck2 = this.props.deck) === null || _this$props$deck2 === void 0 ? void 0 : _this$props$deck2.name : this.selected['name'];
      }
    }, {
      key: "archived",
      get: function get() {
        var _this$props$deck3;
        return this.selected['archived'] === null ? (_this$props$deck3 = this.props.deck) === null || _this$props$deck3 === void 0 ? void 0 : _this$props$deck3.archived : this.selected['archived'];
      }
    }, {
      key: "dailyGoal",
      get: function get() {
        return this.selected['dailyGoal'];
      }
    }, {
      key: "defaultReviewDeck",
      get: function get() {
        var _this$props$deck4;
        return this.selected['defaultReviewDeck'] === null ? (_this$props$deck4 = this.props.deck) === null || _this$props$deck4 === void 0 ? void 0 : _this$props$deck4.defaultReviewDeck : this.selected['defaultReviewDeck'];
      }
    }, {
      key: "useDailyGoal",
      get: function get() {
        var _this$props$deck5;
        return this.selected['useDailyGoal'] === null ? (_this$props$deck5 = this.props.deck) === null || _this$props$deck5 === void 0 ? void 0 : _this$props$deck5.useDailyGoal : this.selected['useDailyGoal'];
      }
    }, {
      key: "color",
      get: function get() {
        var _this$props$deck6;
        return this.selected['color'] === null ? ((_this$props$deck6 = this.props.deck) === null || _this$props$deck6 === void 0 ? void 0 : _this$props$deck6.color) || 'blue' : this.selected['color'];
      }
    }, {
      key: "languageId",
      get: function get() {
        var _this$props$deck7;
        return this.selected['languageId'] === null ? ((_this$props$deck7 = this.props.deck) === null || _this$props$deck7 === void 0 ? void 0 : _this$props$deck7.languageId) || _state.AppUI.targetLanguageId : this.selected['languageId'];
      }
    }, {
      key: "enabledSubmitButton",
      get: function get() {
        return !this.duplicateNameError && !this.dailyGoalIsTooLow && (0, _utils.isPresent)(this.name) && (this.dirtyField('name') || this.dirtyField('color') || this.dirtyField('defaultReviewDeck') || this.dirtyField('useDailyGoal') || this.dirtyField('dailyGoal') || this.dirtyField('languageId') || this.dirtyField('archived'));
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          onSubmit: this.onSubmit,
          name: this.name,
          archived: this.archived,
          dailyGoal: this.dailyGoal,
          color: this.color,
          languageId: this.languageId,
          message: this.message,
          onSetName: this.onSetName,
          onSetColor: this.onSetColor,
          onSetDailyGoal: this.onSetDailyGoal,
          enabledSubmitButton: this.enabledSubmitButton,
          onDeleteDeck: this.onDeleteDeck,
          onDeleteCards: this.onDeleteCards,
          duplicateNameError: this.duplicateNameError,
          askForDeleteConfirmation: this.askForDeleteConfirmation,
          onSetAskForDeleteConfirmation: this.onSetAskForDeleteConfirmation,
          askForResetConfirmation: this.askForResetConfirmation,
          onSetAskForResetConfirmation: this.onSetAskForResetConfirmation,
          askForDeleteCardsConfirmation: this.askForDeleteCardsConfirmation,
          onSetAskForDeleteCardsConfirmation: this.onSetAskForDeleteCardsConfirmation,
          showDeckUpdatedMessage: this.showDeckUpdatedMessage,
          defaultReviewDeck: this.defaultReviewDeck,
          useDailyGoal: this.useDailyGoal,
          onToggleDefaultReviewDeck: this.onToggleDefaultReviewDeck,
          onToggleUseDailyGoal: this.onToggleUseDailyGoal,
          onToggleArchived: this.onToggleArchived,
          onChangeLanguage: this.onChangeLanguage,
          updateReviewAfter: this.updateReviewAfter,
          afterCreateDeck: this.afterCreateDeck,
          dailyGoalMin: this.dailyGoalMin,
          dailyGoalIsTooLow: this.dailyGoalIsTooLow,
          onResetCards: this.onResetCards,
          resettingReviews: this.resettingReviews
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return {
        name: null,
        color: this.props.deck ? null : 'blue',
        defaultReviewDeck: null,
        useDailyGoal: null,
        languageId: null,
        archived: this.props.deck ? this.props.deck.archived : false,
        dailyGoal: this.props.deck ? this.props.deck.dailyGoal : null
      };
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "duplicateNameError", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "askForDeleteConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "askForDeleteCardsConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "askForResetConfirmation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "deletingDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "deletingCards", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "resettingReviews", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "afterCreateDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "dailyGoalMin", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return 12;
    }
  }), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "dailyGoalIsTooLow", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "name", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "name"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "archived", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "archived"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "dailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "dailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "defaultReviewDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "defaultReviewDeck"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "useDailyGoal", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "useDailyGoal"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "languageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "languageId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "enabledSubmitButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "enabledSubmitButton"), _class2.prototype), _class2)) || _class;
};
ReviewDeckCreateWrapper.displayName = 'ReviewDeckCreateWrapper';
var _default = exports["default"] = ReviewDeckCreateWrapper;